<div class="col col--clickable" [ngClass]="{ 'col--subtitle': columnSubtitle != undefined || columnSubtitle != '' }" (click)="onHeaderClick()">
    <div>
        <div>{{ columnName | translate }}</div>
        <div *ngIf="columnSubtitle">{{ columnSubtitle }}</div>
    </div>
    
    <img *ngIf="isSorting" class="sorting-arrow" [ngClass]="{ 'sorting-arrow-up': sortOrder === 'asc' }" src="../assets/images/down-arrow.svg"/>
</div>

